export const TABLE_COL = {
  STT: 'STT',
  TYPE: 'TYPE',
  DATE: 'createDate',
  TRIGGER: 'profilePortfoliosList',
}
